<template>
    <div :class="$style['select-for-taxation']">
        <pt-radio-list :page-size="pageSize" :table-data="tableData" :tableLabels="tableLabels" :selectRow="selectedTax"  @getTableData="getTableData"
         :total-count="totalCount" @selected="selected" ref="table" ></pt-radio-list>
         <div class="button-div">
            <el-button type="primary" @click="submit">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import { taxationTableLabel } from '../finance-manage/pt-taxation-project-manage/taxation.js'
export default {
  props: {
    selectedTax: {
      type: [Array, Object],
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableLabels: taxationTableLabel,
      pageSize: 10,
      tableData: [],
      totalCount: 0,
      selectRow: ''
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        page: page,
        size: this.pageSize
      }
      this.$store.dispatch('getTaxProjctList', data).then(res => {
        this.tableData = res.data
        this.totalCount = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取税务项目失败')
      })
    },
    selected (val) {
      this.selectRow = JSON.parse(JSON.stringify(val))
      this.$emit('selectMealRow', val)
    },
    submit () {
      this.$emit('submitTax', JSON.parse(JSON.stringify(this.selectRow)))
    },
    cancel () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style module lang="less">
.select-for-taxation{
width: 100%
}
</style>
